module.exports = __webpack_public_path__ + "static/media/a50.1096c65a.jpeg";